export const applyBattleEffectCellChanges = (cells = [], changes = [], cols, rows) => {
  const nextCells = new Map();
  cells.forEach((cell) => {
    if (!Number.isFinite(Number(cell?.x)) || !Number.isFinite(Number(cell?.y))) return;
    const x = Math.min(cols - 1, Math.max(0, Math.round(Number(cell.x))));
    const y = Math.min(rows - 1, Math.max(0, Math.round(Number(cell.y))));
    nextCells.set(`${x}|${y}`, { x, y });
  });

  changes.forEach(({ x: rawX, y: rawY, add }) => {
    const x = Math.min(cols - 1, Math.max(0, Math.round(Number(rawX) || 0)));
    const y = Math.min(rows - 1, Math.max(0, Math.round(Number(rawY) || 0)));
    const key = `${x}|${y}`;
    if (add) nextCells.set(key, { x, y });
    else nextCells.delete(key);
  });

  return Array.from(nextCells.values());
};